import { Link } from "react-router-dom";
import "./footer.css";
import video from "../assets/animated.mp4";
const Footer = () => {
  return (
    <div className="footer-container">
      {/* 🔹 Background Video */}
      <video
        autoPlay
        loop
        muted
        playsInline
        className="footer-bg-video"
      >
        <source src={video} type="video/mp4" />
      </video>

      {/* 🔹 Overlay */}
      <div className="footer-overlay"></div>

      {/* 🔹 Footer Content */}
      <div className="container-fluid footer-content mt-5 py-5 wow fadeIn" data-wow-delay="0.1s">
        <div className="container py-5">
          <div className="row g-5">
            {/* Office Info */}
            <div className="col-lg-3 col-md-6">
              <h4 className="text-white mb-4">Our Office</h4>
              <p><i className="fa fa-map-marker-alt me-3"/>G07-Ground Floor-H-61,H Block , Noida Sector-63, Pincode-201309.</p>
              <p><i className="fa fa-phone-alt me-3" />+91-7906576404</p>
              <strong>Email:</strong> 
              <a href="mailto:info@marketmind4u.com"> info@marketmind4u.com</a><br /><div className="d-flex pt-3">
                <a className="btn btn-square btn-light rounded-circle me-2" href="#"><i className="fab fa-twitter" /></a>
                <a className="btn btn-square btn-light rounded-circle me-2" href="#"><i className="fab fa-facebook-f" /></a>
                <a className="btn btn-square btn-light rounded-circle me-2" href="#"><i className="fab fa-youtube" /></a>
                <a className="btn btn-square btn-light rounded-circle me-2" href="#"><i className="fab fa-linkedin-in" /></a>
              </div>
            </div>

            {/* Quick Links */}
            <div className="col-lg-3 col-md-6">
              <h4 className="text-white mb-4">Quick Links</h4>
              <Link className="btn btn-link" to="/about" onClick={() => window.scrollTo(0, 0)}>About Us</Link>
<Link className="btn btn-link" to="/contact" onClick={() => window.scrollTo(0, 0)}>Contact Us</Link>
<Link className="btn btn-link" to="/services" onClick={() => window.scrollTo(0, 0)}>Our Services</Link>
<Link className="btn btn-link" to="/terms" onClick={() => window.scrollTo(0, 0)}>Terms & Conditions</Link>
<Link className="btn btn-link" to="/privacy-policy" onClick={() => window.scrollTo(0, 0)}>Privacy & Policy</Link>

            </div>

            {/* Business Hours */}
            <div className="col-lg-3 col-md-6">
              <h4 className="text-white mb-4">Business Hours</h4>
              <p className="mb-1">Monday - Friday</p>
              <h6 className="text-light">09:00 am - 07:00 pm</h6>
              <p className="mb-1">Saturday</p>
              <h6 className="text-light">09:00 am - 12:00 pm</h6>
              <p className="mb-1">Sunday</p>
              <h6 className="text-light">Closed</h6>
            </div>

            {/* Newsletter */}
            <div className="col-lg-3 col-md-6">
              <h4 className="text-white mb-4">Newsletter</h4>
              <p>Subscribe to our newsletter to get the latest updates, insights, and marketing tips from MarketMind4U.</p>
              <div className="position-relative w-100">
                <input
                  className="form-control bg-transparent text-white border-light w-100 py-3 ps-4 pe-5"
                  type="text"
                  placeholder="Your email"
                />
                <button
                  type="button"
                  className="btn btn-light py-2 position-absolute top-0 end-0 mt-2 me-2"
                >
                  Sign Up
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="container-fluid copyright py-4">
          <div className="container">
            <div className="row text-center text-md-start">
              <div className="col-md-4 text-light">
                © <a className="fw-medium text-light" href="#">MarketMind4U</a>, All Rights Reserved.
              </div>
              <div className="col-md-4 text-light">
                Developed by{" "}
                <a
                  className="fw-medium text-light"
                  target="_blank"
                  rel="noreferrer"
                  href="www.marketmind4u.com"
                >
                  MarketMind4U
                </a>
              </div>
              <div className="col-md-4 text-light text-md-end">
                Empowering Businesses to Grow Smart & Fast
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
